export const lightTheme = {
    body: 'white',
    text: 'black',
    toggleBorder: '#FFF',
    button: "white",
    color: "black"
}

export const darkTheme = {
    body: 'black' ,
    text: '#FAFAFA',
    toggleBorder: '#6B8096',
    button: "black",
    color: "white"
}
